import { Country, Sector } from './meta.models'

// Fallback data for countries when server is unavailable
export const FALLBACK_COUNTRIES: Country[] = [
  {
    id: 1,
    name: 'Polska',
    code: 'PL'
  },
  {
    id: 2,
    name: 'Niemcy',
    code: 'DE'
  },
  {
    id: 3,
    name: 'Hiszpania',
    code: 'ES'
  },
  {
    id: 4,
    name: 'Czechy',
    code: 'CZ'
  },
  {
    id: 37,
    name: 'Rosja',
    code: 'RU'
  },
  {
    id: 38,
    name: 'Ukraina',
    code: 'UA'
  },
  {
    id: 39,
    name: 'Szwecja',
    code: 'SE'
  },
  {
    id: 40,
    name: 'Włochy',
    code: 'IT'
  },
  {
    id: 41,
    name: 'Malta',
    code: 'MT'
  },
  {
    id: 75,
    name: 'Indie',
    code: 'IN'
  },
  {
    id: 76,
    name: 'Australia',
    code: 'AU'
  },
  {
    id: 77,
    name: 'Argentyna',
    code: 'AR'
  },
  {
    id: 78,
    name: 'Turcja',
    code: 'TR'
  },
  {
    id: 79,
    name: 'Francja',
    code: 'FR'
  },
  {
    id: 80,
    name: 'Białoruś',
    code: 'BY'
  },
  {
    id: 113,
    name: 'Egipt',
    code: 'EG'
  },
  {
    id: 114,
    name: 'Zjednoczone Emiraty Arabskie',
    code: 'AE'
  },
  {
    id: 115,
    name: 'Meksyk',
    code: 'MX'
  },
  {
    id: 117,
    name: 'Korea Południowa',
    code: 'KR'
  },
  {
    id: 118,
    name: 'Chiny',
    code: 'CN'
  },
  {
    id: 119,
    name: 'Japonia',
    code: 'JP'
  },
  {
    id: 120,
    name: 'Katar',
    code: 'QA'
  },
  {
    id: 121,
    name: 'Wietnam',
    code: 'VN'
  },
  {
    id: 122,
    name: 'Iran',
    code: 'IR'
  },
  {
    id: 123,
    name: 'Rumunia',
    code: 'RO'
  },
  {
    id: 124,
    name: 'Mozambik',
    code: 'MZ'
  },
  {
    id: 126,
    name: 'Kazachstan',
    code: 'KZ'
  },
  {
    id: 127,
    name: 'Portugalia',
    code: 'PT'
  },
  {
    id: 128,
    name: 'Republika Południowej Afryki',
    code: 'ZA'
  },
  {
    id: 129,
    name: 'Łotwa',
    code: 'LV'
  },
  {
    id: 164,
    name: 'Zimbabwe',
    code: 'ZW'
  },
  {
    id: 165,
    name: 'Filipiny',
    code: 'PH'
  },
  {
    id: 166,
    name: 'Uzbekistan',
    code: 'UZ'
  },
  {
    id: 167,
    name: 'Brazylia',
    code: 'BR'
  },
  {
    id: 169,
    name: 'Gruzja',
    code: 'GE'
  },
  {
    id: 170,
    name: 'Bułgaria',
    code: 'BG'
  },
  {
    id: 171,
    name: 'Irak',
    code: 'IQ'
  },
  {
    id: 172,
    name: 'Grecja',
    code: 'GR'
  },
  {
    id: 173,
    name: 'Estonia',
    code: 'EE'
  },
  {
    id: 174,
    name: 'Cypr',
    code: 'CY'
  },
  {
    id: 175,
    name: 'Urugwaj',
    code: 'UY'
  },
  {
    id: 176,
    name: 'Etiopia',
    code: 'ET'
  },
  {
    id: 177,
    name: 'Litwa',
    code: 'LT'
  },
  {
    id: 178,
    name: 'Norwegia',
    code: 'NO'
  },
  {
    id: 211,
    name: 'Nigeria',
    code: 'NG'
  },
  {
    id: 212,
    name: 'Liban',
    code: 'LB'
  },
  {
    id: 213,
    name: 'Holandia',
    code: 'NL'
  },
  {
    id: 214,
    name: 'Malezja',
    code: 'MY'
  },
  {
    id: 215,
    name: 'Szwajcaria',
    code: 'CH'
  },
  {
    id: 248,
    name: 'Bangladesz',
    code: 'BD'
  },
  {
    id: 249,
    name: 'Kanada',
    code: 'CA'
  },
  {
    id: 250,
    name: 'Tunezja',
    code: 'TN'
  },
  {
    id: 253,
    name: 'Rwanda',
    code: 'RW'
  },
  {
    id: 286,
    name: 'Sierra Leone',
    code: 'SL'
  },
  {
    id: 287,
    name: 'Armenia',
    code: 'AM'
  },
  {
    id: 320,
    name: 'Tadżykistan',
    code: 'TJ'
  },
  {
    id: 353,
    name: 'Nepal',
    code: 'NP'
  },
  {
    id: 424,
    name: 'Gabon',
    code: 'GA'
  },
  {
    id: 354,
    name: 'Izrael',
    code: 'IL'
  },
  {
    id: 425,
    name: 'Gambia',
    code: 'GM'
  },
  {
    id: 426,
    name: 'Palestyna',
    code: 'PS'
  },
  {
    id: 427,
    name: 'Ghana',
    code: 'GH'
  },
  {
    id: 356,
    name: 'Dania',
    code: 'DK'
  },
  {
    id: 428,
    name: 'Gibraltar',
    code: 'GI'
  },
  {
    id: 357,
    name: 'Pakistan',
    code: 'PK'
  },
  {
    id: 429,
    name: 'Kiribati',
    code: 'KI'
  },
  {
    id: 358,
    name: 'Jemen',
    code: 'YE'
  },
  {
    id: 430,
    name: 'Grenlandia',
    code: 'GL'
  },
  {
    id: 163,
    name: 'Irlandia',
    code: 'IE'
  },
  {
    id: 431,
    name: 'Grenada',
    code: 'GD'
  },
  {
    id: 359,
    name: 'Finlandia',
    code: 'FI'
  },
  {
    id: 432,
    name: 'Gwadelupa',
    code: 'GP'
  },
  {
    id: 360,
    name: 'Kuwejt',
    code: 'KW'
  },
  {
    id: 116,
    name: 'Azerbejdżan',
    code: 'AZ'
  },
  {
    id: 42,
    name: 'Wielka Brytania',
    code: 'GB'
  },
  {
    id: 130,
    name: 'Węgry',
    code: 'HU'
  },
  {
    id: 168,
    name: 'Luksemburg',
    code: 'LU'
  },
  {
    id: 125,
    name: 'Stany Zjednoczone',
    code: 'US'
  },
  {
    id: 355,
    name: 'Birma (Myanmar)',
    code: 'MM'
  },
  {
    id: 252,
    name: 'Burundi',
    code: 'BI'
  },
  {
    id: 361,
    name: 'Andora',
    code: 'AD'
  },
  {
    id: 362,
    name: 'Afganistan',
    code: 'AF'
  },
  {
    id: 363,
    name: 'Antigua i Barbuda',
    code: 'AG'
  },
  {
    id: 364,
    name: 'Anguilla',
    code: 'AI'
  },
  {
    id: 365,
    name: 'Albania',
    code: 'AL'
  },
  {
    id: 366,
    name: 'Antyle Holenderskie',
    code: 'AN'
  },
  {
    id: 367,
    name: 'Angola',
    code: 'AO'
  },
  {
    id: 368,
    name: 'Antarktyda',
    code: 'AQ'
  },
  {
    id: 369,
    name: 'Samoa Amerykańskie',
    code: 'AS'
  },
  {
    id: 370,
    name: 'Austria',
    code: 'AT'
  },
  {
    id: 371,
    name: 'Aruba',
    code: 'AW'
  },
  {
    id: 372,
    name: 'Wyspy Alandzkie',
    code: 'AX'
  },
  {
    id: 373,
    name: 'Algieria',
    code: 'DZ'
  },
  {
    id: 374,
    name: 'Bahamy',
    code: 'BS'
  },
  {
    id: 375,
    name: 'Bahrajn',
    code: 'BH'
  },
  {
    id: 376,
    name: 'Barbados',
    code: 'BB'
  },
  {
    id: 377,
    name: 'Belgia',
    code: 'BE'
  },
  {
    id: 378,
    name: 'Bermudy',
    code: 'BM'
  },
  {
    id: 379,
    name: 'Bhutan',
    code: 'BT'
  },
  {
    id: 380,
    name: 'Boliwia',
    code: 'BO'
  },
  {
    id: 381,
    name: 'Bośnia i Hercegowina',
    code: 'BA'
  },
  {
    id: 382,
    name: 'Botswana',
    code: 'BW'
  },
  {
    id: 383,
    name: 'Wyspa Bouveta',
    code: 'BV'
  },
  {
    id: 384,
    name: 'Belize',
    code: 'BZ'
  },
  {
    id: 385,
    name: 'Brytyjskie Terytorium Oceanu Indyjskiego',
    code: 'IO'
  },
  {
    id: 386,
    name: 'Wyspy Salomona',
    code: 'SB'
  },
  {
    id: 387,
    name: 'Brytyjskie Wyspy Dziewicze',
    code: 'VG'
  },
  {
    id: 388,
    name: 'Brunei',
    code: 'BN'
  },
  {
    id: 389,
    name: 'Kambodża',
    code: 'KH'
  },
  {
    id: 390,
    name: 'Kamerun',
    code: 'CM'
  },
  {
    id: 391,
    name: 'Republika Zielonego Przylądka',
    code: 'CV'
  },
  {
    id: 392,
    name: 'Kajmany',
    code: 'KY'
  },
  {
    id: 393,
    name: 'Republika Środkowoafrykańska',
    code: 'CF'
  },
  {
    id: 394,
    name: 'Sri Lanka',
    code: 'LK'
  },
  {
    id: 395,
    name: 'Czad',
    code: 'TD'
  },
  {
    id: 396,
    name: 'Chile',
    code: 'CL'
  },
  {
    id: 397,
    name: 'Tajwan',
    code: 'TW'
  },
  {
    id: 398,
    name: 'Wyspa Bożego Narodzenia',
    code: 'CX'
  },
  {
    id: 399,
    name: 'Wyspy Kokosowe',
    code: 'CC'
  },
  {
    id: 400,
    name: 'Kolumbia',
    code: 'CO'
  },
  {
    id: 401,
    name: 'Komory',
    code: 'KM'
  },
  {
    id: 402,
    name: 'Majotta',
    code: 'YT'
  },
  {
    id: 403,
    name: 'Kongo',
    code: 'CG'
  },
  {
    id: 404,
    name: 'Demokratyczna Republika Konga',
    code: 'CD'
  },
  {
    id: 405,
    name: 'Wyspy Cooka',
    code: 'CK'
  },
  {
    id: 406,
    name: 'Kostaryka',
    code: 'CR'
  },
  {
    id: 407,
    name: 'Chorwacja',
    code: 'HR'
  },
  {
    id: 408,
    name: 'Kuba',
    code: 'CU'
  },
  {
    id: 409,
    name: 'Benin',
    code: 'BJ'
  },
  {
    id: 410,
    name: 'Dominika',
    code: 'DM'
  },
  {
    id: 411,
    name: 'Republika Dominikańska',
    code: 'DO'
  },
  {
    id: 412,
    name: 'Ekwador',
    code: 'EC'
  },
  {
    id: 413,
    name: 'Salwador',
    code: 'SV'
  },
  {
    id: 414,
    name: 'Gwinea Równikowa',
    code: 'GQ'
  },
  {
    id: 415,
    name: 'Erytrea',
    code: 'ER'
  },
  {
    id: 416,
    name: 'Wyspy Owcze',
    code: 'FO'
  },
  {
    id: 417,
    name: 'Falklandy (Malwiny)',
    code: 'FK'
  },
  {
    id: 418,
    name: 'Georgia Południowa i Sandwich Południowy',
    code: 'GS'
  },
  {
    id: 419,
    name: 'Fidżi',
    code: 'FJ'
  },
  {
    id: 420,
    name: 'Gujana Francuska',
    code: 'GF'
  },
  {
    id: 421,
    name: 'Polinezja Francuska',
    code: 'PF'
  },
  {
    id: 422,
    name: 'Francuskie Terytoria Południowe',
    code: 'TF'
  },
  {
    id: 423,
    name: 'Dżibuti',
    code: 'DJ'
  },
  {
    id: 433,
    name: 'Guam',
    code: 'GU'
  },
  {
    id: 434,
    name: 'Gwatemala',
    code: 'GT'
  },
  {
    id: 435,
    name: 'Gwinea',
    code: 'GN'
  },
  {
    id: 436,
    name: 'Gujana',
    code: 'GY'
  },
  {
    id: 437,
    name: 'Haiti',
    code: 'HT'
  },
  {
    id: 438,
    name: 'Wyspy Heard i McDonalda',
    code: 'HM'
  },
  {
    id: 439,
    name: 'Watykan',
    code: 'VA'
  },
  {
    id: 440,
    name: 'Honduras',
    code: 'HN'
  },
  {
    id: 441,
    name: 'Hongkong',
    code: 'HK'
  },
  {
    id: 442,
    name: 'Islandia',
    code: 'IS'
  },
  {
    id: 443,
    name: 'Indonezja',
    code: 'ID'
  },
  {
    id: 444,
    name: 'Wybrzeże Kości Słoniowej',
    code: 'CI'
  },
  {
    id: 445,
    name: 'Jamajka',
    code: 'JM'
  },
  {
    id: 446,
    name: 'Jordania',
    code: 'JO'
  },
  {
    id: 447,
    name: 'Kenia',
    code: 'KE'
  },
  {
    id: 448,
    name: 'Korea Północna',
    code: 'KP'
  },
  {
    id: 449,
    name: 'Kirgistan',
    code: 'KG'
  },
  {
    id: 450,
    name: 'Laos',
    code: 'LA'
  },
  {
    id: 451,
    name: 'Lesotho',
    code: 'LS'
  },
  {
    id: 452,
    name: 'Liberia',
    code: 'LR'
  },
  {
    id: 453,
    name: 'Libia',
    code: 'LY'
  },
  {
    id: 454,
    name: 'Liechtenstein',
    code: 'LI'
  },
  {
    id: 455,
    name: 'Makau',
    code: 'MO'
  },
  {
    id: 456,
    name: 'Madagaskar',
    code: 'MG'
  },
  {
    id: 457,
    name: 'Malawi',
    code: 'MW'
  },
  {
    id: 458,
    name: 'Malediwy',
    code: 'MV'
  },
  {
    id: 459,
    name: 'Mali',
    code: 'ML'
  },
  {
    id: 460,
    name: 'Martynika',
    code: 'MQ'
  },
  {
    id: 461,
    name: 'Mauretania',
    code: 'MR'
  },
  {
    id: 462,
    name: 'Mauritius',
    code: 'MU'
  },
  {
    id: 463,
    name: 'Monako',
    code: 'MC'
  },
  {
    id: 464,
    name: 'Mongolia',
    code: 'MN'
  },
  {
    id: 465,
    name: 'Mołdawia',
    code: 'MD'
  },
  {
    id: 466,
    name: 'Czarnogóra',
    code: 'ME'
  },
  {
    id: 467,
    name: 'Montserrat',
    code: 'MS'
  },
  {
    id: 468,
    name: 'Maroko',
    code: 'MA'
  },
  {
    id: 469,
    name: 'Oman',
    code: 'OM'
  },
  {
    id: 470,
    name: 'Namibia',
    code: 'NA'
  },
  {
    id: 471,
    name: 'Nauru',
    code: 'NR'
  },
  {
    id: 472,
    name: 'Nowa Kaledonia',
    code: 'NC'
  },
  {
    id: 473,
    name: 'Vanuatu',
    code: 'VU'
  },
  {
    id: 474,
    name: 'Nowa Zelandia',
    code: 'NZ'
  },
  {
    id: 475,
    name: 'Nikaragua',
    code: 'NI'
  },
  {
    id: 476,
    name: 'Niger',
    code: 'NE'
  },
  {
    id: 477,
    name: 'Norfolk',
    code: 'NF'
  },
  {
    id: 478,
    name: 'Mariany Północne',
    code: 'MP'
  },
  {
    id: 479,
    name: 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych',
    code: 'UM'
  },
  {
    id: 480,
    name: 'Mikronezja',
    code: 'FM'
  },
  {
    id: 481,
    name: 'Wyspy Marshalla',
    code: 'MH'
  },
  {
    id: 482,
    name: 'Palau',
    code: 'PW'
  },
  {
    id: 483,
    name: 'Panama',
    code: 'PA'
  },
  {
    id: 484,
    name: 'Papua-Nowa Gwinea',
    code: 'PG'
  },
  {
    id: 485,
    name: 'Paragwaj',
    code: 'PY'
  },
  {
    id: 486,
    name: 'Peru',
    code: 'PE'
  },
  {
    id: 487,
    name: 'Pitcairn',
    code: 'PN'
  },
  {
    id: 488,
    name: 'Gwinea Bissau',
    code: 'GW'
  },
  {
    id: 489,
    name: 'Timor Wschodni',
    code: 'TL'
  },
  {
    id: 490,
    name: 'Portoryko',
    code: 'PR'
  },
  {
    id: 491,
    name: 'Reunion',
    code: 'RE'
  },
  {
    id: 492,
    name: 'Saint-Barthélemy',
    code: 'BL'
  },
  {
    id: 493,
    name: 'Święta Helena i Zależne',
    code: 'SH'
  },
  {
    id: 494,
    name: 'Saint Kitts i Nevis',
    code: 'KN'
  },
  {
    id: 495,
    name: 'Saint Lucia',
    code: 'LC'
  },
  {
    id: 496,
    name: 'Saint-Martin',
    code: 'MF'
  },
  {
    id: 497,
    name: 'Saint-Pierre i Miquelon',
    code: 'PM'
  },
  {
    id: 498,
    name: 'Saint Vincent i Grenadyny',
    code: 'VC'
  },
  {
    id: 499,
    name: 'San Marino',
    code: 'SM'
  },
  {
    id: 500,
    name: 'Wyspy Świętego Tomasza i Książęca',
    code: 'ST'
  },
  {
    id: 501,
    name: 'Arabia Saudyjska',
    code: 'SA'
  },
  {
    id: 502,
    name: 'Senegal',
    code: 'SN'
  },
  {
    id: 503,
    name: 'Serbia',
    code: 'RS'
  },
  {
    id: 504,
    name: 'Seszele',
    code: 'SC'
  },
  {
    id: 505,
    name: 'Singapur',
    code: 'SG'
  },
  {
    id: 506,
    name: 'Słowacja',
    code: 'SK'
  },
  {
    id: 507,
    name: 'Słowenia',
    code: 'SI'
  },
  {
    id: 508,
    name: 'Somalia',
    code: 'SO'
  },
  {
    id: 509,
    name: 'Sahara Zachodnia',
    code: 'EH'
  },
  {
    id: 510,
    name: 'Sudan',
    code: 'SD'
  },
  {
    id: 511,
    name: 'Surinam',
    code: 'SR'
  },
  {
    id: 512,
    name: 'Svalbard i Jan Mayen (wyspa)',
    code: 'SJ'
  },
  {
    id: 513,
    name: 'Suazi',
    code: 'SZ'
  },
  {
    id: 514,
    name: 'Syria',
    code: 'SY'
  },
  {
    id: 515,
    name: 'Tajlandia',
    code: 'TH'
  },
  {
    id: 516,
    name: 'Togo',
    code: 'TG'
  },
  {
    id: 517,
    name: 'Tokelau',
    code: 'TK'
  },
  {
    id: 518,
    name: 'Tonga',
    code: 'TO'
  },
  {
    id: 519,
    name: 'Trynidad i Tobago',
    code: 'TT'
  },
  {
    id: 520,
    name: 'Turkmenistan',
    code: 'TM'
  },
  {
    id: 521,
    name: 'Wyspy Turks i Caicos',
    code: 'TC'
  },
  {
    id: 522,
    name: 'Tuvalu',
    code: 'TV'
  },
  {
    id: 523,
    name: 'Uganda',
    code: 'UG'
  },
  {
    id: 524,
    name: 'Macedonia',
    code: 'MK'
  },
  {
    id: 525,
    name: 'Guernsey',
    code: 'GG'
  },
  {
    id: 526,
    name: 'Jersey',
    code: 'JE'
  },
  {
    id: 527,
    name: 'Wyspa Man',
    code: 'IM'
  },
  {
    id: 528,
    name: 'Tanzania',
    code: 'TZ'
  },
  {
    id: 529,
    name: 'Wyspy Dziewicze Stanów Zjednoczonych',
    code: 'VI'
  },
  {
    id: 530,
    name: 'Burkina Faso',
    code: 'BF'
  },
  {
    id: 531,
    name: 'Wenezuela',
    code: 'VE'
  },
  {
    id: 532,
    name: 'Wallis i Futuna',
    code: 'WF'
  },
  {
    id: 533,
    name: 'Samoa',
    code: 'WS'
  },
  {
    id: 534,
    name: 'Zambia',
    code: 'ZM'
  },
  {
    id: 535,
    name: 'Niue',
    code: 'NU'
  },
  {
    id: 536,
    name: 'Inny Kraj',
    code: 'ZZ'
  },
  {
    id: 537,
    name: 'Kosowo',
    code: 'XK'
  },
  {
    id: 538,
    name: 'Irlandia Północna',
    code: 'GB'
  }
]

// Fallback data for sectors when server is unavailable
export const FALLBACK_SECTORS: Sector[] = [
  {
    id: 1,
    name: 'IT'
  },
  {
    id: 2,
    name: 'Retail'
  },
  {
    id: 3,
    name: 'HR'
  },
  {
    id: 4,
    name: 'PRODUCTION'
  },
  {
    id: 5,
    name: 'EDUCATION'
  },
  {
    id: 6,
    name: 'CONSULTING'
  },
  {
    id: 7,
    name: 'TRAVEL MANAGMENT'
  },
  {
    id: 8,
    name: 'DISTRIBUTION'
  },
  {
    id: 9,
    name: 'OUTSOURCING'
  },
  {
    id: 10,
    name: 'PHARMACY'
  },
  {
    id: 11,
    name: 'SALES'
  },
  {
    id: 12,
    name: 'FINANCES'
  },
  {
    id: 13,
    name: 'Real Estate'
  },
  {
    id: 14,
    name: 'TELECOMMUNICATION'
  },
  {
    id: 15,
    name: 'Automotive'
  },
  {
    id: 16,
    name: 'construction industry'
  },
  {
    id: 17,
    name: 'ENERGY'
  },
  {
    id: 18,
    name: 'Tourism'
  },
  {
    id: 19,
    name: 'BPO\/SCC'
  },
  {
    id: 20,
    name: 'Services'
  },
  {
    id: 21,
    name: 'Call Center'
  },
  {
    id: 22,
    name: 'recruitment'
  },
  {
    id: 23,
    name: 'Beauty'
  },
  {
    id: 24,
    name: 'Air Transport'
  },
  {
    id: 25,
    name: 'HORECA'
  },
  {
    id: 26,
    name: 'INSURANCE'
  },
  {
    id: 28,
    name: 'Legal'
  },
  {
    id: 29,
    name: 'Medical'
  },
  {
    id: 30,
    name: 'Design'
  },
  {
    id: 31,
    name: 'Gastronomy'
  },
  {
    id: 32,
    name: 'Banking'
  },
  {
    id: 33,
    name: 'Marketing'
  },
  {
    id: 34,
    name: 'Advertising'
  },
  {
    id: 35,
    name: 'Entertainment'
  },
  {
    id: 36,
    name: 'Science'
  },
  {
    id: 37,
    name: 'Sports'
  },
  {
    id: 38,
    name: 'Debt Collection'
  },
  {
    id: 39,
    name: 'Student'
  },
  {
    id: 72,
    name: 'Army'
  },
  {
    id: 73,
    name: 'Health'
  },
  {
    id: 74,
    name: 'Cleaning services'
  },
  {
    id: 75,
    name: 'AUDIT'
  },
  {
    id: 76,
    name: 'engineering'
  },
  {
    id: 77,
    name: 'Cleaning'
  },
  {
    id: 78,
    name: 'Retired'
  },
  {
    id: 27,
    name: 'Public Sector'
  },
  {
    id: 79,
    name: 'ADMINISTRATION'
  },
  {
    id: 80,
    name: 'Agencja nieruchomości'
  },
  {
    id: 81,
    name: 'ARTIST'
  },
  {
    id: 82,
    name: 'Fundacja'
  },
  {
    id: 83,
    name: 'banking'
  },
  {
    id: 84,
    name: 'Transport'
  },
  {
    id: 85,
    name: 'Hotel Industry'
  },
  {
    id: 86,
    name: 'AGRICULTURE'
  },
  {
    id: 87,
    name: 'Media'
  }
]
